<template>
    <div class="cont-tit">
        <h2 class="page-title">Differentiation</h2>
        <p class="page-desc">The OSE-B2C/B2B/O2O Commerce Ver.1.2 platform is a multi-channel complex service e-commerce platform built on the AWS cloud,
            Provides technical stability and scalability. <br>
            It ensures high security by thoroughly complying with national information protection regulations such as security protocols and ISMS authentication from customers. <br>
            Our platform's discriminatory feature is that it greatly improves the accessibility and convenience of global customers through a user-friendly interface and selectable multilingual support.</p>
    </div>
    <div class="differentiation">
        <section class="differentiation__sec differentiation__sec1">
            <ul class="differentiation__list">
                <li class="differentiation__item">
                    <img src="../../assets/resource/icon/differentiation-icon01.svg" alt="">
                    <div class="differentiation__text">
                        <h3>Between Various Services Organic Linked Platform</h3>
                        <p>We lay the foundation for the inflow of new services by expanding online and offline service channels. <br>
                            Expand various O2O service channels such as mobile web, hybrid app, tablet, and IoT.</p>
                    </div>
                </li>
                <li class="differentiation__item">
                    <img src="../../assets/resource/icon/differentiation-icon02.svg" alt="">
                    <div class="differentiation__text">
                        <h3>Stable Architecture Integrated Administrator Of The Background</h3>
                        <p>The core of the O2O platform <br>
                            Improved performance and stability of Integrated Administrator</p>
                    </div>
                </li>
                <li class="differentiation__item">
                    <img src="../../assets/resource/icon/differentiation-icon03.svg" alt="">
                    <div class="differentiation__text">
                        <h3>through big data analysis Building a statistical system Based on customer-tailored big data</h3>
                        <p>Mobile web, hybrid apps, tablets, IoT, etc. <br>
                            Expanding various O2O service channels</p>
                    </div>
                </li>
                <li class="differentiation__item">
                    <img src="../../assets/resource/icon/differentiation-icon04.svg" alt="">
                    <div class="differentiation__text">
                        <h3>AI personalized recommendations</h3>
                        <p>AI personalized recommendations</p>
                    </div>
                </li>
            </ul>
        </section>
        <section class="differentiation__sec differentiation__sec2">
            <h3 class="sec-tit">01. Organic linkage platform between various services</h3>
            <p class="sec-desc">We lay the foundation for the inflow of new services by expanding online and offline service channels. <br>
                Expand various O2O service channels such as mobile web, hybrid app, tablet, and IoT.</p>
            <div class="differentiation__sec2-img">
                <img src="../../assets/resource/img/differentiation-img001.png" alt="">
            </div>

            <div class="text-box type2">
                <h4 class="text-box__tit">characteristic</h4>
                <ul class="text-box__list">
                    <li class="text-box__item">We provide customer satisfaction services through O2O, front service, and customized product recommendations.</li>
                    <li class="text-box__item">“A differentiated O2O/B2B/B2C platform” utilizes seamless partnership services between companies.</li>
                    <li class="text-box__item">It improves the management convenience of “Channel Integration Manager” and “Affiliate/Supplier Manager” and is based on multi-channel linkage efficiency.</li>
                </ul>
            </div>
        </section>

        <section class="differentiation__sec differentiation__sec3">
            <h3 class="sec-tit">02. Integrated manager based on stable architecture</h3>
            <p class="sec-desc">Through DB tuning and migration, introduction of standard framework, and use of open source <br>
                Improves the performance and stability of the integrated manager, which is the core of the O2O platform.</p>

            <div class="differentiation__sec2-img mt80">
                <img src="../../assets/resource/img/differentiation-img002.png" alt="">
            </div>

            <div class="differentiation__sec-box">
                <p>Stable integrated manager renewal using open technology and open source-based S/W tools</p>
            </div>

            <div class="differentiation__sec2-img">
                <img src="../../assets/resource/img/differentiation-img003.png" alt="">
            </div>

            <ul class="text-list">
                <li class="text-item">
                    <p>
                        <b>Safe operating environment</b><br>
                        Compatible Architecture
                    </p>
                </li>
                <li class="text-item">
                    <p>
                        Improved <b>system speed</b> <br>
                        Continuous <b>DB tuning</b>
                    </p>
                </li>
                <li class="text-item">
                    <p>
                        For internal and <br>
                        external linkages <br>
                        <b>standard interface</b>
                    </p>
                </li>
                <li class="text-item">
                    <p>
                        <b>Compliance with web</b> <br>
                        <b>standards and accessibility</b> <br>
                        device independent
                    </p>
                </li>
            </ul>

            <div class="text-box">
                <p class="text-box__desc">OSE-Commerce Ver.1.2 is an integrated management system developed based on a stable architecture and standard framework, <br>
                    supporting integration with various sales channels and ERP systems. <br>
                    It ensures fast speed and stable system operation, and improves compatibility by utilizing developed standard technologies and open source.
                    Additionally, it provides a standard interface for linking with external systems.</p>
            </div>
        </section>

        <section class="differentiation__sec differentiation__sec4">
            <h3 class="sec-tit">03. Building a Statistical System through Big Data Analysis and Custom Solutions</h3>
            <p class="sec-desc">Through statistical-based big data analysis and construction using product log analysis, purchase and shopping cart data
                Increases the scalability of custom systems.</p>
            <div class="differentiation__sec2-img">
                <img src="../../assets/resource/img/differentiation-img04.png" alt="">
            </div>

            <div class="text-box">
                <p class="text-box__desc">OSE-Commerce Ver.1.2 builds big data by collecting and analyzing customer product logs, purchases, and shopping cart data. <br>
                    Based on this, we provide customized services to customers, such as customized product recommendations and recent route analysis.</p>
            </div>
        </section>

        <section class="differentiation__sec differentiation__sec5">
            <h3 class="sec-tit">04. AI customized recommendation</h3>
            <p class="sec-desc">Our company transforms customer experiences through AI personalized recommendations. Personalized product recommendations and customer churn prediction,
                From sales forecasting to intelligent inventory management, we analyze all data to provide optimal solutions. Experience our smart service right now!</p>

            <ul class="differentiation__img-list">
                <li class="differentiation__img-item" v-for="(item, index) in 6">
                    <img :src="require(`@/assets/resource/img/differentiation-site1${index}.png`)" alt="">
                </li>
            </ul>
        </section>
    </div>
</template>
<script>
    export default {

    }
</script>
<style>

</style>